import { useTranslation } from 'react-i18next';
import Heading from 'components/Home/Heading';
import PriceCard from 'components/Home/PriceCard';

import under1k from 'public/static/images/home/price/under1k.jpg';
import under2k from 'public/static/images/home/price/under2k.jpg';
import under3k from 'public/static/images/home/price/under3k.jpg';
import under4k from 'public/static/images/home/price/under4k.jpg';
import under5k from 'public/static/images/home/price/under5k.jpg';
import under10k from 'public/static/images/home/price/under10k.jpg';
import under15k from 'public/static/images/home/price/under15k.jpg';
import under20k from 'public/static/images/home/price/under20k.jpg';

import priceCSS from '../styles/Home/Price';

const PRICES = [
  { price: '1,000', image: under1k },
  { price: '2,000', image: under2k },
  { price: '3,000', image: under3k },
  { price: '4,000', image: under4k },
  { price: '5,000', image: under5k },
  { price: '10,000', image: under10k },
  { price: '15,000', image: under15k },
  { price: '20,000', image: under20k },
];

export default function Price(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="prices-container">
      <Heading title={t('home.prices.title')} />
      <ul>
        {PRICES.map((price) => (
          <PriceCard key={price.price} price={price.price} image={price.image} />
        ))}
      </ul>
      <style jsx>{priceCSS}</style>
    </div>
  );
}
